import { inject, Injectable, signal } from '@angular/core';
import { allCurrrencies } from '@views/common/components/header/components/lang-currency-selector/models/currency.model';
import { ListDropdownItem } from '@vueling-ng/vy-ds/src/lib/components/globals/list-dropdown';
import { EnabledSessionsStorageKeys } from 'app/shared/models/configs-sessions-storage';
import { AppState } from 'app/shared/state/models/app-state.model';
import { StateManagerService } from 'app/shared/state/state-manager.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly _stateManagerService = inject(StateManagerService);

  public currentCurrency = signal<string>('');

  public initialize(currency: string): void {
    const currentState = JSON.parse(sessionStorage.getItem(EnabledSessionsStorageKeys.state) ?? '{}') as AppState;
    if (currentState?.currency) {
      this.setCurrency(currentState.currency);
      return;
    }
    this.setCurrency(currency);
  }

  public getAllCurrency(): ListDropdownItem[] {
    return allCurrrencies.map((currency) => {
      return {
        value: currency,
        label: `common.currencies.${currency}`,
        labelSuffix: currency
      };
    });
  }

  public setCurrency(currency: string): void {
    this.currentCurrency.set(currency);
    this.updateCurrencyInState();
  }

  public getParserCurrentCurrency(): ListDropdownItem {
    return {
      value: this.currentCurrency(),
      label: `common.currencies.${this.currentCurrency()}`,
      labelSuffix: this.currentCurrency()
    };
  }

  private updateCurrencyInState(): void {
    this._stateManagerService.update((draft) => (draft.currency = this.currentCurrency()));
  }
}
